import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { CsplTable as Table } from "../../../../components";

const columns = [
  {
    label: "Investment Name",
    className: "column-field",
    columnName: "investmentName",
  },
  {
    label: "Amount",
    className: "column-dateTimeModified",
    columnName: "amount",
  },
  {
    label: "Percentage",
    className: "column-previousValue",
    columnName: "percentage",
  },
];
const data = [
  {
    investmentName: "Pre Tax",
    amount: 2000,
    percentage: 10,
  },
  {
    investmentName: "Pre Tax",
    amount: 2000,
    percentage: 10,
  },
  {
    investmentName: "Pre Tax",
    amount: 2000,
    percentage: 10,
  },
  {
    investmentName: "Pre Tax",
    amount: 2000,
    percentage: 10,
  },
];
export const SourceDetails = (props) => {
  const [expand, setExpand] = useState(false);

  return (
    <div className="transaction-history-withdrawal">
      <div className="transaction-history-withdrawal-header">Sources</div>
      <div className="source-detail-transfer">
        {[1, 2, 3].map((_) => {
          return (
            <div className="card-source-detail">
              <div className="small-card-source-detail">
                <FontAwesomeIcon
                  icon={faChevronDown}
                  size="md"
                  color="#333333"
                  onClick={() => setExpand(!expand)}
                />
                <div className="card-header-text">
                  {"After Tax"} - Investments
                </div>
              </div>
              {expand && (
                <div className="expanded-sorce-detail-card">
                  <div className="left-side-pane">
                    <div className="current-holdings-header">
                      Current Holdings
                    </div>
                    <div className="investment-number">03 investments</div>
                    {[1, 2, 3].map((e) => {
                      return (
                        <div className="investment-card-details">
                          <div className="investment-name-text">
                            The columbia Cap mid
                          </div>
                          <div className="investment-amount-details">
                            <div className="investment-amount-column">
                              <span className="investment-amount-number">
                                $ 2000
                              </span>
                              <span className="amount-header">Amout</span>
                            </div>
                            <div className="investment-amount-column">
                              <span className="investment-amount-number">
                                37%
                              </span>
                              <span className="amount-header">Percentage</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="right-side-pane">
                    <div className="current-holdings-header">
                      Future Holdings
                    </div>
                    <div className="investment-number">04 investments</div>
                    <Table className="future-investment-table">
                      <Table.Thead>
                        <Table.Tr>
                          {columns.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {data.map((e, i) => {
                          return (
                            <Table.Tr key={i}>
                              <Table.Td>{e.investmentName}</Table.Td>
                              <Table.Td>{e.amount}</Table.Td>
                              <Table.Td>{e.percentage}</Table.Td>
                            </Table.Tr>
                          );
                        })}
                      </Table.Tbody>
                    </Table>
                    <div className="future-holdings-footer">
                      <span>Total</span>
                      <span>$ 12000</span>
                      <span>100 %</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
